import { inputConfig, priceConfig } from '../config';
import { createRadio, openAndScroll, validatePhone } from '../helpers';
import { Controller } from "@hotwired/stimulus";

let state = {
  cuttype: '',
  colorstripes: '',
  cutlength: '',
  time: '',
  timeType: '',
  place: '',
  price: '',
  name: '',
  contact: '',
};

export default class extends Controller {
  static targets = [
    "form",
    "cuttype",
    "colorstripes",
    "colorstripesForm",
    "cutlength",
    "time",
    "specificTime",
    "specificTimeRadio",
    "place",
    "price",
    "pricelist",
    "specificPrice",
    "specificPriceRadio",
    "contact",
    "submitButton",
    "phone",
    "actualPrice",
  ];

  static values = {
    cuttype: String,
    colorstripes: String,
    cutlength: String,
    time: String,
    timeType: String,
    place: String,
    prices: Array,
    price: Number,
    priceType: String,
    contact: String,
  };

  initialize() {
    this.valid = false;

    inputConfig.forEach(function(i) {
      const el = document.getElementById(i.id);
      i.data.forEach(function(d) {
        if(i.prepend === true) {
          el.prepend(createRadio(i.id, i.action, d));
        } else {
          el.appendChild(createRadio(i.id, i.action, d));
        }
      });
    });

    // initialize price list
    this.updatePrices();
  }

  updatePrices() {
    this.priceValue = -1;

    const wrapper = this.pricelistTarget;
    wrapper.querySelectorAll('label.radio.price').forEach(function(el) {
      el.remove();
    });

    const priceType = this.cuttypeValue || "cut";
    const prices = priceConfig[priceType];
    prices.forEach(function(price) {
      wrapper.prepend(createRadio("price", "bid#price", {
        value: price,
        label: `${price} kr`,
        labelClass: "price",
      }));
    });
  }

  cuttype(e) {
    this.cuttypeValue = e.target.value;

    if(this.cuttypeValue == "color-stripes") {
      this.colorstripesTarget.classList.remove("disabled");
      this.colorstripesFormTarget.style.display = "block";
      openAndScroll(this.colorstripesTarget, this.cuttypeTarget);
    } else {
      this.colorstripesTarget.classList.add("disabled");
      this.colorstripesTarget.classList.add("closed");
      openAndScroll(this.cutlengthTarget, this.cuttypeTarget);
    }

    this.update();
    this.updatePrices();
  }

  colorstripes(e) {
    this.colorstripesValue = e.target.value;
    this.cuttypeValue = e.target.value;

    openAndScroll(this.cutlengthTarget, this.colorstripesTarget);

    this.update();
    this.updatePrices();
  }

  cutlength(e) {
    this.cutlengthValue = e.target.value;
    this.update();
    openAndScroll(this.timeTarget, this.cutlengthTarget);
  }

  time(e) {
    this.timeTypeValue = e.target.value;

    if(this.timeTypeValue == "specific-time") {
      this.placeTarget.classList.remove("closed");
      this.specificTimeTarget.focus();
    } else {
      this.timeValue = e.target.value;
      openAndScroll(this.placeTarget, this.timeTarget);
    }

    this.update();
  }

  specificTime(e) {
    const el = this.specificTimeTarget;
    if(el.value != '') {
      //el.classList.remove("error");
      this.timeValue = el.value;
    } else {
      //el.classList.add("error");
    }

    this.update();
  }

  specificTimeFocus(e) {
    const el = this.specificTimeTarget;
    if(this.timeTypeValue != "specific-time" && el == document.activeElement) {
      document.querySelectorAll('input[name=time]').forEach(function(input) {
        input.removeAttribute("checked");
      });
      this.specificTimeRadioTarget.setAttribute("checked", "checked");
    }
    if(this.timeTypeValue == "specific-time" && el != document.activeElement) {
      this.specificTimeTarget.focus();
    }

    this.timeTypeValue = "specific-time";

    this.update();
  }

  place(e) {
    this.placeValue = e.target.value;
    this.update();
    openAndScroll(this.priceTarget, this.placeTarget);
  }

  price(e) {
    this.priceTypeValue = "";

    if(e.target.value == "specific-price") {
      this.specificPriceTarget.focus();
      this.contactTarget.classList.remove("closed");
      this.priceTypeValue = "specific-price";
    } else {
      this.priceValue = parseInt(e.target.value);
      this.priceTypeValue = "price";
      openAndScroll(this.contactTarget, this.priceTarget);
    }

    this.update();
  }

  specificPriceFocus(e) {
    const el = this.specificPriceTarget;
    if(this.priceTypeValue != "specific-price" && el == document.activeElement) {
      document.querySelectorAll('input[name=price]').forEach(function(input) {
        input.removeAttribute("checked");
      });
      this.specificPriceRadioTarget.setAttribute("checked", "checked");
      this.contactTarget.classList.remove("closed");
    }
    if(this.priceTypeValue == "specific-price" && el != document.activeElement) {
      this.specificPriceTarget.focus();
    }
  }

  specificPrice(e) {
    const el = this.specificPriceTarget;
    const currentPrice = this.priceValue;
    const newPrice = parseInt(el.value);
    if(newPrice && el.value != '') {
      //el.classList.remove("error");
      this.priceValue = newPrice;
    } else {
      //el.classList.add("error");
    }

    this.update();
  }

  contact(e) {
    this.contactValue = e.target.value;
    this.update();
  }

  update() {
    state.cuttype = this.cuttypeValue;
    state.colorstripes = this.colorstripesValue;
    state.cutlength = this.cutlengthValue;
    state.time = this.timeValue;
    state.timeType = this.timeTypeValue;
    state.place = this.placeValue;
    state.price = this.priceValue;
    state.priceType = this.priceTypeValue;
    state.contact = this.contactValue;

    if(!state.contact && this.phoneTarget.value) {
      state.contact = this.phoneTarget.value;
    }
    if(this.validateState()) {
      this.submitButtonTarget.removeAttribute("disabled");
      this.submitButtonTarget.innerHTML = "Send inn";
    } else {
      this.submitButtonTarget.setAttribute("disabled", true);
      this.submitButtonTarget.innerHTLM = "Fyll ut skjemaet..";
    }
  }

  validateState() {
    let log = false;
    if(state.cuttype == '') {
      if(log) console.log('cuttype not valid', state.cuttype);
      return false;
    }
    if(state.cuttype == 'color-stripes' && state.colorstripes == '') {
       if(log) console.log('colorstripes not valid for cut type', state.cuttype, state.colorstripes);
      return false;
    }
    if(state.cutlength == '') {
      if(log) console.log('cutlength not valid', state.cutlength);
      return false;
    }
    if(state.time == '') {
      if(log) console.log('time not valid', state.time);
      return false;
    } else if(state.time == 'specific-time' && state.specificTime == '') {
      if(log) console.log('specific-time not valid', state.specificTime);
      return false;
    }
    if(state.price == '') {
      if(log) console.log('price not valid', state.price);
      return false;
    } else if(state.price == 'specific-price' && state.specificPrice == '') {
      if(log) console.log('specific-price not valid', state.specificPrice);
      return false;
    }
    if(state.place == '') {
      if(log) console.log('place not valid', state.place);
      return false;
    }
    if(state.price == -1) {
      if(log) console.log('price not valid', state.price);
      return false;
    }
    if(!validatePhone(state.contact)) {
      if(log) console.log('phone not valid', state.contact);
      return false;
    }

    if(log) console.log('OK');
    return true;
  }

  submit(e) {
    e.preventDefault();

    this.update();

    alert("Ikke implementert i denne versjonen");
  }
}

